import fetchDocumentToStory from "./API/fetchDocumentToStory";
import fetchFolderToCategory from "./API/fetchFolderToCategory";
import fetchFolderWithChildrenToCategoryWithChildren from "./API/fetchFolderWithChildrenToCategoryWithChildren";
import fetchFooterToFooter from "./API/fetchFooterToFooter";
import fetchLandingPageToLandingPage from "./API/fetchLandingPageToLandingPage";
import { fetchHierarchyToHierarchy } from "./API/fetchShopToShop";
import fetchMetadataToMeta from "./API/fetchMetadataToMeta";
import searchByTopicProductToProductSlim from "./API/searchByTopicProductToProductSlim";
import searchProductToProductSlim from "./API/searchProductToProductSlim";
import APIImageToImage from "./Object/APIImageToImage";
import APIMetaSEOComponentToSEO from "./Object/APIMetaSEOComponentToSEO";
import APIProductVariantToProductVariant from "./Object/APIProductVariantToProductVariant";
import fetchDocumentToPage from "./API/fetchDocumentToPage";
import { fetchProductToProduct } from "./API/fetchProductToProduct";
import APIOTCComponentToOTC from "./Object/APIOTCComponentToOTC";
import fetchFolderToFolder from "./API/fetchFolderToFolder";
import FetchFolderToBlog from "./API/fetchFolderToBlog";

export type DataMapperContext = {
  locale?: string;
  language: string;
};

export const DataMapper = (context?: DataMapperContext) => {
  return {
    API: {
      Call: {
        fetchDocumentToStory: fetchDocumentToStory,
        fetchDocumentToPage: fetchDocumentToPage,
        fetchFolderToCategory: (withChildren: boolean = false) => {
          if (withChildren) {
            return fetchFolderWithChildrenToCategoryWithChildren;
          }
          return fetchFolderToCategory;
        },
        fetchFooterToFooter: fetchFooterToFooter,
        fetchLandingPageToLandingPage: fetchLandingPageToLandingPage,
        fetchProductToProduct: fetchProductToProduct,
        fetchHierarchyToHierarchy: fetchHierarchyToHierarchy,
        searchByTopicProductToProductSlim: searchByTopicProductToProductSlim,
        searchProductToProductSlim: searchProductToProductSlim,
        fetchMetadataToMeta: fetchMetadataToMeta,
        fetchFolderToFolder: fetchFolderToFolder,
        fetchBlogFolderWithChildren: FetchFolderToBlog,
      },
      Object: {
        APIImageToImage: APIImageToImage,
        APIMetaSEOComponentToSEO: APIMetaSEOComponentToSEO,
        APIProductVariantToProductVariant: APIProductVariantToProductVariant,
        APIOTCComponentToOTC: APIOTCComponentToOTC,
      },
    },
  };
};

export type DataMapperInterface = ReturnType<typeof DataMapper>;
